import { Flex, Text } from '@wyz/ui';
import * as React from 'react';
type Props = {
  label: React.ReactNode;
  value?: string | number | React.ReactNode;
};
function SearchValuePreview(params: Props) {
  return (
    <Flex className='space-x-2' wrap='wrap'>
      <Text heading='xs' color='secondary-gray' className='text-truncate'>
        {params.label}
        {':'}
      </Text>
      <Text
        heading='xs'
        color='primary'
        weight='semi-bold'
        className='text-nowrap'
      >
        {params.value ?? '-'}
      </Text>
    </Flex>
  );
}
export default SearchValuePreview;
